import styled from 'styled-components';

export const Wrapper = styled.button`
  background: none;
  border: none;
  padding: 0;
  z-index: 5;
  top: 50%;
  transform: translateY(-50%);
  right: 1.8rem;
  display: none;
  cursor: pointer;
  transition: left 500ms cubic-bezier(0.6, 0.05, 0.28, 0.91);
  position: absolute;

  @media (max-width: 991px) {
    display: block;
  }

  ${({ sidebar }) =>
    sidebar &&
    `
			right: 18%;
			top: 1.4rem;
		
			@media (max-width: 991px) {
				right: 35%;
				position: fixed;
			}
		
			@media (max-width: 575px) {
				right: 66%;
			}
	`}
`;
